export default __webpack_public_path__ + "static/media/J_Janela.0256dfe2.mp3";